export class BaseEndpoints {
  public static readonly V1 = 'v1/';
  public static readonly V2 = 'v2/';
  public static readonly SETTINGS = BaseEndpoints.V1 + 'settings/';
  public static readonly SETTINGSV2 = BaseEndpoints.V2 + 'settings/';
  public static readonly INIT_DATADOG_CONFIG = BaseEndpoints.V1 + 'datadog/init';
}
